import apiClient from './apiClient';
import { CertTool, Utils } from 'certtool';



export const certificationProcess = async (singleData, tableName) => {
  console.log('Starting custom certification logic processing...');
  console.log('SingleData: ', singleData)
  


  try {

    // getting WASM
    let wasmBytes
    try {
        const wasmResp = await apiClient.get(`/getWasm`, {
            responseType: 'arraybuffer'
        })

        if (wasmResp.status !== 200) throw new Error(`Server returned error: ${wasmResp}`);

        const buffer = wasmResp.data;
        wasmBytes = new Uint8Array(buffer);

    } catch (error) {
        throw new Error(`Error getting chain data: ${error.message}`);
    }
    console.log(`WASM:`);
    console.log(wasmBytes);  


    // creating and setting certtool
    const ct = new CertTool();
    try {
        // CertTool.setChainData(
        //     Object.values(chainDataJson.metadataBytes),
        //     Object.values(chainDataJson.specVersion),
        //     Object.values(chainDataJson.transactionVersion),
        //     Object.values(chainDataJson.genesisHash),
        // );
        // ct.setJsonSchema(dataSchema);
        // ct.setCertifierPubKey(certifierPubKey);
        await ct.initWasm(wasmBytes);
    } catch (error) {
        throw new Error(`Error initializing certification tool`);
    }


    // SET CERTPACKET
    const originalDataToCertify = singleData  // {foo: 42, bar: 'asdasd'};
    let certPacket;
    try {
        certPacket = ct.createCertificationDataPacket(originalDataToCertify) 
    } catch (error) {
        throw new Error(`Could not create certification data packet`);
    }
    console.log(`certification packet:`);
    console.log(Utils.hexEncode(certPacket));

    const createCertificateReqData = {
        originalData: originalDataToCertify,
        certPacket: [...certPacket],
        tableName: tableName
    }


     // CertifyData API call
    let certifyDataReplyJson;
    try {
        const certifyDataReply = await apiClient.post(`/certifyData`, createCertificateReqData, {
          'content-type': 'application/json'
        });
        
        certifyDataReplyJson = await certifyDataReply.data;
    } catch (error) {
        throw new Error(`Sign error: ${error.message}`)
    }

    console.log('CERTIFICATE CREATION RESPONSE')
    console.log(certifyDataReplyJson);

    
    return certifyDataReplyJson;
    
  } catch (error) {
    console.error('Error in custom certification logic:', error);
    throw error;
  }
};



// Default export for convenience
export default {
  certificationProcess,
};
